import type { ChangeEvent } from 'react';
import { useLanguage } from '../i18n/context';
import { getUi } from '../i18n/ui';
import { LOCALES, LOCALE_LABEL, type Locale } from '../i18n/types';
import styles from './LanguageSwitcher.module.css';

interface LanguageSwitcherProps {
  onLocaleChange?: (locale: Locale) => void;
}

export function LanguageSwitcher({ onLocaleChange }: LanguageSwitcherProps) {
  const { locale, setLocale } = useLanguage();
  const ui = getUi(locale);

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const next = event.target.value as Locale;
    setLocale(next);
    onLocaleChange?.(next);
  };

  return (
    <div className={styles.switcher}>
      <label htmlFor="language-switcher" className="visually-hidden">
        {ui.languageSwitcher.ariaLabel}
      </label>
      <select
        id="language-switcher"
        className={styles.select}
        value={locale}
        onChange={handleChange}
        aria-label={ui.languageSwitcher.ariaLabel}
      >
        {LOCALES.map((code) => (
          <option key={code} value={code}>
            {LOCALE_LABEL[code]}
          </option>
        ))}
      </select>
    </div>
  );
}
